import { format } from 'date-fns-tz';
import { timeZones } from '.';

export default () => {
  const now = Date.now();

  return timeZones
    .map((zoneName) => ({
      label: `(UTC ${format(now, 'xxx', { timeZone: zoneName })}) ${zoneName}`,
      value: zoneName,
      utcOffset: format(now, 'xx', { timeZone: zoneName })
    }))
    .sort((a, b) => {
      return a.utcOffset - b.utcOffset || a.value.localeCompare(b.value);
    });
};
